export default __webpack_public_path__ + "static/media/hm-l22-img.9e860e60.webp";